import { render, staticRenderFns } from "./CommEmailModal.vue?vue&type=template&id=67972374&scoped=true&"
import script from "./CommEmailModal.vue?vue&type=script&lang=js&"
export * from "./CommEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./CommEmailModal.vue?vue&type=style&index=0&id=67972374&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67972374",
  null
  
)

export default component.exports